module.exports = "varying vec2 vUv;\n\nvoid main()\n{\n    vUv = uv;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/Passes/GlitchPass/shader-vertex.glsl
// module id = hhuS
// module chunks = 1